<template>
  <div class="selection:bg-[var(--terracotta)] selection:text-white">
    <AppHeader />
    <router-view v-slot="{ Component, route }">
      <Transition name="page" mode="out-in">
        <component :is="Component" :key="route.path" />
      </Transition>
    </router-view>
    <AppFooter />
    <JoinCommunityModal />
  </div>
</template>


<script>
import AppHeader from './components/AppHeader.vue'
import AppFooter from './components/AppFooter.vue'
import JoinCommunityModal from './components/JoinCommunityModal.vue'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter,
    JoinCommunityModal
  }
}
</script>

<style>
/* Page transition animations - theme consistent */
.page-enter-active {
  transition: opacity 0.6s ease-out, transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.page-leave-active {
  transition: opacity 0.4s ease-in, transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.page-enter-from {
  opacity: 0;
  transform: translateY(20px) scale(0.98);
}

.page-leave-to {
  opacity: 0;
  transform: translateY(-10px) scale(0.98);
}

.page-enter-to,
.page-leave-from {
  opacity: 1;
  transform: translateY(0) scale(1);
}
</style>
